import axios from "axios";
import {
  TERMINACION_REQUEST,
  TERMINACION_SUCCESS,
  TERMINACION_FAILURE,
  TERMINACION_DOCS_SUCCESS,
  TERMINACION_SAVE_SUCCESS,
  TERMINACION_FORMAS_SUCCESS,
  TERMINACION_PARCIALIDADES_SUCCESS,
} from "./types";
import { PATH } from "../../utils";

const api = axios.create({ baseURL: PATH });

const authHeader = () => {
  const token = localStorage.getItem("tokenadmin") || localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const handle401 = (error) => {
  if (error?.response?.status === 401) {
    localStorage.removeItem("token");
    localStorage.removeItem("tokenadmin");
    window.location.href = "/login";
  }
};

export const actionGetFormasTerminacion = () => async (dispatch) => {
  try {
    const resp = await api.get("/tribunal/formas-terminacion", { headers: authHeader() });
    dispatch({ type: TERMINACION_FORMAS_SUCCESS, payload: resp.data });
    return resp.data;
  } catch (error) {
    handle401(error);
  }
};

export const actionGetTerminacion = (id_tribunal) => async (dispatch) => {
  dispatch({ type: TERMINACION_REQUEST });
  try {
    const [termResp, docsResp] = await Promise.all([
      api.get(`/tribunal/${id_tribunal}/terminacion`, { headers: authHeader() }),
      api.get(`/tribunal/${id_tribunal}/terminacion/documentos`, { headers: authHeader() }),
    ]);
    dispatch({ type: TERMINACION_SUCCESS, payload: termResp.data });
    dispatch({ type: TERMINACION_DOCS_SUCCESS, payload: docsResp.data });
    return { terminacion: termResp.data, documentos: docsResp.data };
  } catch (error) {
    handle401(error);
    dispatch({ type: TERMINACION_FAILURE, payload: { error: error?.message } });
  }
};

export const actionSaveTerminacion = (id_tribunal, payload) => async (dispatch) => {
  dispatch({ type: TERMINACION_REQUEST });
  try {
    const resp = await api.post(`/tribunal/${id_tribunal}/terminacion`, payload, {
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    dispatch({ type: TERMINACION_SAVE_SUCCESS, payload: resp.data });
    return resp.data;
  } catch (error) {
    handle401(error);
    dispatch({ type: TERMINACION_FAILURE, payload: { error: error?.message } });
    throw error;
  }
};

export const actionDeleteTerminacion = (id_tribunal) => async (dispatch) => {
  dispatch({ type: TERMINACION_REQUEST });
  try {
    const resp = await api.delete(`/tribunal/${id_tribunal}/terminacion`, { headers: authHeader() });
    dispatch({ type: TERMINACION_SAVE_SUCCESS, payload: resp.data });
    return resp.data;
  } catch (error) {
    handle401(error);
    dispatch({ type: TERMINACION_FAILURE, payload: { error: error?.message } });
    throw error;
  }
};

export const actionUploadTerminacionDoc = (id_tribunal, file) => async (dispatch) => {
  const formData = new FormData();
  formData.append("documento", file);
  try {
    const resp = await api.post(`/tribunal/${id_tribunal}/terminacion/documentos`, formData, {
      headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
    });
    return resp.data;
  } catch (error) {
    handle401(error);
    throw error;
  }
};

export const actionGetParcialidades = (id_tribunal) => async (dispatch) => {
  try {
    const resp = await api.get(`/tribunal/${id_tribunal}/terminacion/parcialidades`, { headers: authHeader() });
    dispatch({ type: TERMINACION_PARCIALIDADES_SUCCESS, payload: resp.data });
    return resp.data;
  } catch (error) {
    handle401(error);
  }
};

export const actionSaveParcialidades = (id_tribunal, parcialidades) => async () => {
  try {
    const resp = await api.post(
      `/tribunal/${id_tribunal}/terminacion/parcialidades`,
      { parcialidades },
      { headers: { ...authHeader(), "Content-Type": "application/json" } }
    );
    return resp.data;
  } catch (error) {
    handle401(error);
    throw error;
  }
};

export const actionDeleteTerminacionDoc = (id_tribunal, id_doc) => async () => {
  try {
    await api.delete(`/tribunal/${id_tribunal}/terminacion/documentos/${id_doc}`, {
      headers: authHeader(),
    });
  } catch (error) {
    handle401(error);
    throw error;
  }
};

export const actionSaveConstanciaTerminacion = (id_tribunal, { fecha_cumplimiento, notas_cumplimiento, file }) => async (dispatch) => {
  const formData = new FormData();
  formData.append("payload", JSON.stringify({ fecha_cumplimiento, notas_cumplimiento }));
  if (file) formData.append("archivo_constancia", file);
  try {
    const resp = await api.put(
      `/tribunal/${id_tribunal}/terminacion/constancia`,
      formData,
      { headers: { ...authHeader(), "Content-Type": "multipart/form-data" } }
    );
    return resp.data;
  } catch (error) {
    handle401(error);
    throw error;
  }
};
